import * as React from 'react';
import { VideoBoxPlayProps } from '../VideoBox.types';
import VectorImage from '../../VectorImage/viewer/VectorImage';
import styles from './style/VideoBox.scss';

const VideoBoxPlay: React.FC<VideoBoxPlayProps> = ({
  id,
  vectorImageProps,
  shouldRender,
}) => {
  return shouldRender ? (
    <VectorImage
      id={id}
      className={styles.videoboxPlay}
      {...vectorImageProps}
    />
  ) : null;
};

export default VideoBoxPlay;
